import { getNativeInfo } from "../jsbridge"
import { EUFY_BABY_APPLICATION_NAME, EUFY_HOME_APPLICATION_NAME, EUFY_LIFT_APPLICATION_NAME, EUFY_MEGA_APPLICATION_NAME, EUFY_SECURITY_APPLICATION_NAME } from "./constants"
import { getCookie } from "./cookie"

// 根据 appName 返回对应的请求头名称 跟运营平台上的数据对齐
export const normalizeAppName = (appName: string) => {
  const lowerAppName = (appName || '').toLowerCase()
  if (lowerAppName.includes('security')) {
    return EUFY_SECURITY_APPLICATION_NAME
  } else if (lowerAppName.includes('life')) {
    return EUFY_LIFT_APPLICATION_NAME
  } else if (lowerAppName.includes('home')) {
    return EUFY_HOME_APPLICATION_NAME
  } else if (lowerAppName.includes('mega') || lowerAppName === 'eufy') {
    return EUFY_MEGA_APPLICATION_NAME
  }else if (lowerAppName.includes('baby')) {
    return EUFY_BABY_APPLICATION_NAME
  } else if (lowerAppName.includes('care')) {
    return EUFY_BABY_APPLICATION_NAME
  }
  return EUFY_SECURITY_APPLICATION_NAME // 默认返回
}

export const getAppHeaderName = async () => {
  let appName = getCookie('app_name')
    try {
      const nativeInfo = await getNativeInfo()
      appName = normalizeAppName(nativeInfo?.appName)
    } catch (error) {
      // 优先从userAgent中获取appName,然后再从cookie中获取
    const uaMatchAppName = navigator.userAgent.match(/AppName=(\w+)/)
    const uaAppName = uaMatchAppName ? uaMatchAppName[1] : null
    appName = uaAppName ? normalizeAppName(uaAppName) : getCookie('app_name')
    }
  return appName
}